import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumbs from '@/components/base/Breadcrumbs';
import NewsletterForm from '@/components/feature/NewsletterForm';
import { siteFaqs, siteName } from '@/mocks/articles';
import usePageMeta from '@/hooks/usePageMeta';
import JsonLd from '@/components/base/JsonLd';

export default function Faq() {
  usePageMeta(
    '常见问题',
    `${siteName} 常见问题解答：关于爆料信源可信度、参数曝光与官方参数区别、价格预测方法、未发布产品图甄别以及如何第一时间获取更新。`
  );

  return (
    <>
      <Navbar />
      <JsonLd
        data={{
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: siteFaqs.map((f) => ({
            '@type': 'Question',
            name: f.q,
            acceptedAnswer: { '@type': 'Answer', text: f.a },
          })),
        }}
      />
      <main id="main" className="bg-background-50">
        <div className="mx-auto w-full max-w-4xl px-4 py-10 md:px-6 md:py-14">
          <Breadcrumbs items={[{ label: '首页', to: '/' }, { label: '常见问题' }]} />

          <div className="mt-6 text-center">
            <div className="mb-2 inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-800">
              <i className="ri-question-line" aria-hidden="true" />
              FAQ
            </div>
            <h1 className="font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl">关于每日新料，你可能想知道</h1>
            <p className="mx-auto mt-3 max-w-2xl text-sm leading-7 text-foreground-600 md:text-base">
              从信源可信度、内容边界到如何第一时间获取更新，我们把最常见的疑问集中在这里解答。
            </p>
          </div>

          <div className="mt-10 flex flex-col gap-4">
            {siteFaqs.map((f, i) => (
              <div key={f.q} className="rounded-2xl border border-background-200 bg-background-100 p-6 md:p-7">
                <h2 className="flex items-start gap-3 font-heading text-base font-bold leading-snug text-foreground-900 md:text-lg">
                  <span className="mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-500 text-xs font-black text-background-50">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span>Q：{f.q}</span>
                </h2>
                <p className="mt-3 pl-10 text-sm leading-7 text-foreground-700 md:text-[15px] md:leading-8">A：{f.a}</p>
              </div>
            ))}
          </div>

          {/* 订阅与联系 */}
          <div className="mt-12 rounded-3xl border border-primary-100 bg-gradient-to-br from-primary-50 via-background-50 to-accent-50 p-8 text-center md:p-10">
            <h2 className="font-heading text-xl font-black text-foreground-900 md:text-2xl">还有疑问？或想第一时间收到爆料？</h2>
            <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              订阅电子报接收最新摘要，或直接给我们留言，我们会认真回复每一位读者。
            </p>
            <div className="mt-6">
              <NewsletterForm id="faq-newsletter" />
            </div>
            <Link
              to="/about#contact"
              className="mt-5 inline-flex h-11 items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-mail-send-line" aria-hidden="true" />
              联系我们 {siteName}
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}